<div class="role-form-container container mt-0 pt-0">
  @if (isLoading()) {
  <av-loading-item icon="badge"></av-loading-item>
  }

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <!-- Top Bar: Name Input and Submit -->
    <div class="p-3">
      <div class="name-container px-5 pt-3 pb-2 d-block gap-3">
        <div class="header mb-3">
          <h1 class="text-3xl font-bold m-0">
            {{
            (isEditMode()
            ? 'app.settings.role_management.form.edit_title'
            : 'app.settings.role_management.form.create_title'
            ) | translate
            }}
          </h1>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <div class="input-wrapper">
            <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
              <mat-label>{{
                'app.settings.role_management.form.name_label' | translate
                }}</mat-label>
              <input matInput formControlName="name"
                [placeholder]="'app.settings.role_management.form.name_placeholder' | translate" />
              @if (form.get('name')?.pending) {
              <mat-spinner matSuffix diameter="20" class="me-3"></mat-spinner>
              }
            </mat-form-field>
            @if (form.get('name')?.hasError('required') && (form.get('name')?.touched || form.get('name')?.dirty)) {
            <p class="text-danger fs-sm m-0 mt-0">{{
              'app.settings.role_management.form.name_required' | translate
              }}</p>
            }
            @if (form.get('name')?.hasError('name_duplicated') && (form.get('name')?.touched ||
            form.get('name')?.dirty)) {
            <span class="text-danger text-xs m-0 mt-0">{{
              'app.settings.role_management.form.name_duplicated' | translate
              }}</span>
            }
          </div>
          <div class="d-flex gap-2">
            @if (isEditMode() && currentUser()?.hasPermission(userPermissions.ROLE_DELETE)) {
            <span
              [matTooltip]="(role()?.users_count ?? 0) > 0 ? ('app.settings.role_management.form.delete_disabled_tooltip' | translate) : ''">
              <button type="button" mat-stroked-button color="warn" [disabled]="(role()?.users_count ?? 0) > 0"
                (click)="onDeleteRole()">
                <mat-icon>delete</mat-icon>
                {{ 'app.settings.role_management.form.delete_button' | translate }}
              </button>
            </span>
            }
            <button type="submit" mat-raised-button color="primary"
              [disabled]="form.invalid || isLoading() || isSubmitting() || form.get('name')?.pending">
              <mat-icon>save</mat-icon>
              {{ 'shared.general.buttons.save' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <av-content-container>
      <div class="d-flex justify-content-between">
        <div class="">
          <div class="d-flex align-items-center">
            <mat-icon>flag</mat-icon>
            <h5 class="font-bold p-0 m-0">
              {{ 'app.settings.role_management.form.permissions_title' | translate }}
            </h5>
          </div>
          <p class="text-sm ps-3 p-0 m-0">
            {{ 'app.settings.role_management.form.permissions_subtitle' | translate }}
          </p>
        </div>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="permission-search-field">
          <input matInput
            [placeholder]="'app.settings.role_management.form.search_permissions_placeholder' | translate"
            [value]="permissionSearchTerm()" (input)="permissionSearchTerm.set($any($event.target).value)" />
          @if (permissionSearchTerm()) {
          <mat-icon matSuffix class="cursor-pointer" (click)="permissionSearchTerm.set('')">close</mat-icon>
          }@else{
          <mat-icon matSuffix>search</mat-icon>
          }
        </mat-form-field>
      </div>

      @for (section of filteredPermissionConfig(); track section.title; let lestSection = $last) {
      <div class="col-12">
        @for (group of section.groups; track group.name; let lastGroup = $last ) {
        <div class="d-flex items-center gap-2 pt-3">
          <mat-icon class="icon-sm">flag</mat-icon>
          <span class="font-bold">{{
            'app.settings.role_management.groups.' + group.name | translate
            }}</span>
        </div>
        <div class="d-flex flex-wrap gap-2 rounded-md m-0">
          @for (perm of group.items; track perm.id) {
          <mat-checkbox color="primary" [checked]="selectedPermissionIds().has(perm.id!)"
            (change)="togglePermission(perm, $event.checked)" class="permission-checkbox p-0 m-0 me-3">
            <span class="">{{'shared.models.permissions.' + perm.name + '.title' | translate}}</span>
            <mat-icon [matTooltip]="'shared.models.permissions.' + perm.name + '.description' | translate">info</mat-icon>
          </mat-checkbox>
          }
        </div>
        @if (!(lestSection && lastGroup)) {
        <mat-divider></mat-divider>
        }
        }
      </div>

      }
    </av-content-container>
  </form>
</div>